/* eslint-disable @typescript-eslint/naming-convention */
import { Box, IconButton, Checkbox } from '@mui/material'
import emotionStyled from '@emotion/styled'
import { styled } from '@mui/material/styles'
import { colors, typography } from '@resiliatech/birdsong'
import TextField, { TextFieldProps } from '@mui/material/TextField'
import { colors as oldColors } from 'Themes/Colors'

interface CustomProps {
  titleLength?: number
  completed?: boolean
}

type StyledTextFieldProps = TextFieldProps & CustomProps

export const TaskContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'shouldHighlight',
})<{ shouldHighlight: boolean }>`
  border: ${({ shouldHighlight }) =>
    shouldHighlight ? `1px solid ${colors.interactive.borderFocusOrange}` : ''};
  border-radius: 8px;
  align-items: center;
  cursor: pointer;
  display: flex;
  position: relative;
  padding: 8px;
  width: 100%;
  z-index: 1;

  &:hover {
    background-color: ${oldColors.lightestBlue};
  }
`

export const TaskItemRow = styled(Box)`
  align-items: center;
  display: flex;
  gap: 7px;
  height: 100%;
`

export const TaskDetails = styled(Box)`
  justify-content: center;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 0 16px;
  width: 100%;
`

export const Status = styled(Checkbox)`
  height: 24px;
  padding: 0;
  '& .muisvgicon-root': {
    font-size: 24px;
  }
  '&.mui-checked': {
    color: ${oldColors.black};
  }
`

export const TitleInput = styled(TextField, {
  shouldForwardProp: (prop) => prop !== 'titleLength' && prop !== 'completed',
})<StyledTextFieldProps>(({ titleLength, completed }) => ({
  paddingBottom: '1px',
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      border: 'none',
    },
    '&:hover fieldset': {
      borderColor: 'none',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'none',
    },
  },
  '&.MuiTextField-root': {
    textDecoration: titleLength && completed ? 'line-through' : 'none',
  },
}))

export const TaskTitle = emotionStyled('div', {
  shouldForwardProp: (prop) => prop !== 'titleLength' && prop !== 'completed',
})<StyledTextFieldProps>`
  ${typography.baseline.regularSans};
  display: flex;
  margin: 0px;
  text-align: left;
  text-decoration: ${({ titleLength, completed }) =>
    titleLength && completed ? 'line-through' : 'none'};
  width: 100%;
`

export const ItemBody = styled(Box)`
  display: flex;
  align-items: center;
  width: 100%;
`

export const TaskActions = styled(Box)`
  display: flex;
  align-items: center;
`

export const AddAcademyResourceButton = styled(IconButton)`
  color: ${oldColors.resiliaBlue};
  cursor: pointer;
  padding: 8px;
`

export const RemoveAcademyResourceButton = styled(IconButton)`
  color: ${oldColors.resiliaBlue};
  cursor: pointer;
  padding: 8px;
`

export const AddOwner = styled(IconButton)`
  color: ${oldColors.resiliaBlue};
  cursor: pointer;
  padding: 8px;
`

export const Delete = styled(IconButton)`
  color: ${oldColors.coral};
`

export const DeleteTask = styled(IconButton)`
  color: ${oldColors.coral};
  cursor: pointer;
  padding: 8px;
`

export const PopoverContent = styled(Box)`
  background: white;
  height: 143px;
  width: 565px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
`

export const SelectContainer = styled(Box)`
  width: 100%;
`

export const AvatarAction = styled(Box)`
  cursor: pointer;
`

export const SearchBarBox = styled(Box)`
  padding: 0 20px 40px 20px;
  width: 525px;
`

export const CloseButton = styled(IconButton)`
  padding-top: 2px;
`

export const SupplementalItem = styled(Box)`
  padding-left: 32px;
  max-width: fit-content;
`

export const Clickable = styled('button')({
  alignItems: 'center',
  backgroundColor: 'inherit',
  border: 'none',
  cursor: 'pointer',
  display: 'flex',
  flexGrow: 1,
  height: '100%',
  margin: 0,
  padding: 0,
  width: '100%',
})
